import { Box, Flex, Text } from "@chakra-ui/react";
import Markdown from "react-markdown";
import MessageAccordion from "./MessageAccordion";

const Message = ({ role, content, type, name }) => {
    const isUser = role === "user";
    const isAssistant = role === "assistant";

    if (isAssistant) {
        return (
            <Box p={2} px={6}>
                <Markdown>{content}</Markdown>
            </Box>
        );
    }
    if (isUser)
        return (
            <Flex
                alignSelf={"flex-end"}
                bg={"blue.500"}
                color={"white"}
                borderRadius="lg"
                p={2}
                pb={0}
                maxW={"80%"}
            >
                <Text>{content}</Text>
            </Flex>
        );

    return <MessageAccordion type={type} content={content} name={name}/>
};

export default Message;
